import React, { useContext, useEffect, useState } from "react";
import { Panel } from "../../../common/components/panel/panel";
import StandAloneContext from "../../../common/components/context/StandAloneContext";
import { TableV } from "../../../common/components/table/tablev2";
import { RoeFileColumnsDefinitions } from "./RoeFileColumnsDefinitions";
import { ErrorColumnsDefinitions } from "../Error/ErrorColumnsDefinitions";
import { GetRoeImportById, GetValidationErrorsByImportId } from "../../../services/ImportDetailService";
import { Status } from "../../../models/StandAloneData";
import logger from '../../../logger';

export const ROE: React.FC<{ rowsPerPage?: any }> = ({
  rowsPerPage = 25,
}) => {
  const { state } = useContext(StandAloneContext);
  const [errors, setErrors] = useState(false);
  const [loadingRoe, setLoadingRoe] = useState(true);
  const [loadingError, setLoadingError] = useState(true);
  const [data, setData] = useState<any[]>([]);
  const [errorData, setErrorData] = useState<any[]>([]);

  async function getROEFileData() {
    try {
      const response = await GetRoeImportById(state.importId);
      if (response) {
        const formattedData = {
          fileName: state?.fileName,
          payDate: response?.payDate,
          periodEndDate: response?.periodEndDate,
          roeCount: response?.roeCount.toString(),
          totalInsurableHours: response?.totalInsurableHours.toString(),
          totalInsurableAmount: response?.totalInsurableAmount.toString(),
        };
        setData([formattedData]);
      }
      setLoadingRoe(false);
    } catch (error) {
      setLoadingRoe(false);
      logger.error(error);
    }
  }

  async function getValidationErrors() {
    try {
      const resp = await GetValidationErrorsByImportId(state.importId);
      if (resp && resp.length > 0) {
        setErrorData(resp);
      }
      setLoadingError(false);
    } catch (error) {
      setLoadingError(false);
      logger.error(error);
    }
  }

  useEffect(() => {
    if (state.status === Status.Error || state.status === Status.TransmissionError) {
      getValidationErrors();
      setErrors(true);
    } else {
      getROEFileData();
      setErrors(false);
    }
  }, [state.status]);

  return (
    <Panel fullWidth={true}>
      {!errors && (
        <Panel.Block>
          <TableV
            testId="canada-standalone-ui-roe"
            isLoading={loadingRoe}
            columns={RoeFileColumnsDefinitions()}
            data={data}
            dataKey="Canada"
            dataLength={data.length}
            description="ROE File Data"
            noDataText="No data"
            addItemText=""
            tableHeight="83vh"
            rowsPerPage={rowsPerPage}
          />
        </Panel.Block>
      )}

      {errors && (
        <Panel.Block>
          <TableV
            testId="canada-standalone-ui-roe-error"
            isLoading={loadingError}
            columns={ErrorColumnsDefinitions()}
            data={errorData}
            dataKey="Canada"
            dataLength={errorData.length}
            description="ROE Error Data"
            noDataText=""
            addItemText=""
            tableHeight="83vh"
            rowsPerPage={rowsPerPage}
          />
        </Panel.Block>
      )}
    </Panel>
  );
};
